module.exports = new __parcel__URL__("logo.aed67aaa.svg").toString();